import { render, staticRenderFns } from "./SaleTransaction.vue?vue&type=template&id=5c3d18ba&"
import script from "./SaleTransaction.vue?vue&type=script&lang=js&"
export * from "./SaleTransaction.vue?vue&type=script&lang=js&"
import style0 from "./SaleTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports